import { useTheme, type ThemeMode } from "../theme";

const NEXT: Record<ThemeMode, ThemeMode> = { system: "light", light: "dark", dark: "system" };
const ICON: Record<ThemeMode, string> = {
  system: "bi-circle-half",
  light: "bi-sun",
  dark: "bi-moon-stars",
};
const LABEL: Record<ThemeMode, string> = { system: "System", light: "Light", dark: "Dark" };

/** Header icon button that cycles System → Light → Dark. */
export default function ThemeToggle() {
  const { mode, setMode } = useTheme();
  return (
    <button
      type="button"
      className="header-action"
      title={`Theme: ${LABEL[mode]} (click to change)`}
      aria-label={`Theme: ${LABEL[mode]}`}
      onClick={() => setMode(NEXT[mode])}
    >
      <i className={`bi ${ICON[mode]}`}></i>
    </button>
  );
}
